import OrderInfo from './OrderInfo'

export default OrderInfo
